import type { FaqsQueryParams } from './contracts/faqContracts'
import type { SupportTicketsQueryParams } from './contracts/supportTicketContracts'

// Query-keys factory for the support module.
export const supportKeys = {
  all: ['support'] as const,
  faqCategories: () => [...supportKeys.all, 'faqCategories'] as const,
  faqs: (params: FaqsQueryParams) => [...supportKeys.all, 'faqs', params] as const,
  ticketCategories: () => [...supportKeys.all, 'ticketCategories'] as const,
  ticketLists: () => [...supportKeys.all, 'tickets'] as const,
  tickets: (params: SupportTicketsQueryParams) => [...supportKeys.ticketLists(), params] as const,
  ticketDetail: (id: string) => [...supportKeys.all, 'ticket', id] as const,
}
